module.exports = __webpack_public_path__ + "static/media/candle.28462e78.jpg";